var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#B92B27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 18.7c-.8-1.6-1.8-3.3-3.7-3.3-.4 0-.7.1-1.1.2l-.4-1.2c.5-.1 1-.2 1.5-.2 2.4 0 3.5 1.6 4.4 3.4.3 0 .6 0 .8-.1l.4 1.2c-.4.1-.7.1-1.1.1-.2 0-.5 0-.7 0l-.2-.1zm-.1-3.4c2.3 0 4.1-2.2 4.1-5 0-2.7-1.8-5-4.1-5s-4.1 2.2-4.1 5c0 2.7 1.8 5 4.1 5z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuora);
export default __webpack_public_path__ + "static/media/quora.230094a1cc537e72d1989fb994e8288c.svg";
export { ForwardRef as ReactComponent };